<template>
  <video :value="value" ref="refQRCapture" :width="width" :height="height" :style="'max-width: ' + width + 'px;'"></video>
</template>

<script>
import Const from "../constants";
import QrScanner from "qr-scanner";
export default {
  props: {
    value: {
      type: String,
      default: ""
    },
    width: {
      type: Number,
      default: 500
    },
    height: {
      type: Number || String,
      default: "auto"
    }
  },
  data() {
    return {
      qr: this.value
    };
  },
  methods: {
    goScan() {
      this.$nextTick(() => {
        // console.log(QrScanner.toString());
        // QrScanner.scanImage(this.$refs.refQRCapture)
        //   .then(result => {
        //     this.fp.setInfoMessage(result);
        //     this.isCameraActive = false;
        //   })
        //   .catch(error => {
        //     var err = error || "Не е открит QR код.";
        //     this.fp.setErrorMessage(err.replace("Camera not found.", "Не е открита камера."));
        //     this.isCameraActive = false;
        //   });

        const qrScanner = new QrScanner(
          this.$refs.refQRCapture,
          result => {
            qrScanner.stop();
            this.qr = result;
            this.fp.lastQRCode = this.qr;
            this.$emit("input", this.qr);
            this.$emit("change", this.qr);
            this.fp.exitMode(Const.Modes.QRScanner);
          },
          () => {
            /** ignored */
            // this.fp.setErrorMessage("err cb" + error);
            // this.fp.exitMode(Const.Modes.QRScanner);
          },
          300
        );
        qrScanner.start().catch(error => {
          var err = error || "Не е открит QR код.";
          this.fp.setErrorMessage(err.replace("Camera not found.", "Не е открита камера."));
          this.fp.exitMode(Const.Modes.QRScanner);
        });
      });
    }
  },
  computed: {},
  mounted() {
    this.goScan();
  }
};
</script>